export const mockConsumerAbi = [
  {
    type: 'constructor',
    stateMutability: 'nonpayable',
    inputs: [
      { type: 'address', name: 'erinaceusVRF', internalType: 'address' },
    ],
  },
  {
    type: 'error',
    name: 'OnlyErinaceusCanFulfill',
    inputs: [
      { type: 'address', name: 'have', internalType: 'address' },
      { type: 'address', name: 'want', internalType: 'address' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'uint256', name: '', internalType: 'uint256' }],
    name: 'currentId',
    inputs: [],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [
      { type: 'address', name: '', internalType: 'contract ErinaceusVRF' },
    ],
    name: 'erinaceus',
    inputs: [],
  },
  {
    type: 'function',
    stateMutability: 'nonpayable',
    outputs: [],
    name: 'generateRandomWords',
    inputs: [
      { type: 'bytes32', name: 'keyHash', internalType: 'bytes32' },
      { type: 'uint64', name: 'subId', internalType: 'uint64' },
      { type: 'uint16', name: 'requestConfirmations', internalType: 'uint16' },
      { type: 'uint32', name: 'callbackGasLimit', internalType: 'uint32' },
      { type: 'uint32', name: 'numWords', internalType: 'uint32' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'uint256[]', name: '', internalType: 'uint256[]' }],
    name: 'getRandom',
    inputs: [{ type: 'uint256', name: 'id', internalType: 'uint256' }],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'uint256', name: '', internalType: 'uint256' }],
    name: 'randomWord',
    inputs: [
      { type: 'uint256', name: '', internalType: 'uint256' },
      { type: 'uint256', name: '', internalType: 'uint256' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'nonpayable',
    outputs: [],
    name: 'rawFulfillRandomWords',
    inputs: [
      { type: 'uint256', name: 'requestId', internalType: 'uint256' },
      { type: 'uint256[]', name: 'randomWords', internalType: 'uint256[]' },
    ],
  },
]
